import { RESET_WIDGET } from '../../actions/common';
import {
  SET_AMOUNT_ERROR,
  SET_LAYOUT_STATE,
  SET_WIDGET_ERROR,
  SET_WIDGET_STATUS,
  SET_WIDGET_VISIBILITY,
} from '../../actions/layout';
import { TReduxActions } from '../../types/actions';
import { EWidgetMode, EWidgetStatus, ILayoutState } from '../../types/redux/layout';

const defaultState: ILayoutState = {
  isVisible: false,
  mode: EWidgetMode.Deposit,
  isModal: false,
  status: EWidgetStatus.Initial,
  amountError: null,
  widgetError: null,
};

export const layoutReducer = (state: ILayoutState = defaultState, action: TReduxActions) => {
  switch (action.type) {
    case SET_LAYOUT_STATE:
      return {
        ...state,
        ...action.payload,
      };

    case SET_WIDGET_STATUS:
      return {
        ...state,
        status: action.payload,
      };

    case SET_WIDGET_VISIBILITY:
      return {
        ...state,
        isVisible: action.payload,
      };

    case SET_AMOUNT_ERROR:
      return {
        ...state,
        amountError: action.payload,
      };

    case SET_WIDGET_ERROR:
      return {
        ...state,
        widgetError: action.payload,
      };

    case RESET_WIDGET:
      return {
        ...defaultState,
      };

    default:
      return state;
  }
};
